import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-bell-filled",
  "use": "rt-base-bell-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-bell-filled\"><path d=\"M512 896c-18.5 0-33.8-14-35.8-32h71.5c-1.9 18-17.2 32-35.7 32z\" /><path d=\"M920 784h-56V463.9c0-178.7-135-327.4-308-349.2V108c0-24.2-19.8-44-44-44s-44 19.8-44 44v6.7c-173 21.8-308 170.5-308 349.2V784h-56c-22 0-40 18-40 40s18 40 40 40h308.1c2.1 53.3 46.1 96 99.9 96s97.8-42.7 99.9-96H920c22 0 40-18 40-40s-18-40-40-40zM724 660c0 24.3-19.7 44-44 44s-44-19.7-44-44V492c0-24.3 19.7-44 44-44s44 19.7 44 44v168z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/bell-filled.svg
// module id = 1646
// module chunks = 228